import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; 

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// SweetAlert2 for notifications
import Swal from "sweetalert2";

import { getOneScanPermissionApi, updateScanPermissionApi } from "api/scan";
import { getAllRevendeursApi } from "api/superAdmin";
import { getAllEventApi } from "api/events";

function ModifierScan() {
  const navigate = useNavigate();
  const { scanId } = useParams();

  const [formData, setFormData] = useState({
    fromReseller: null,
    selectedEvents: null,
    canScan: false,
  });

  const [revendeurOptions, setRevendeurOptions] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [scanRes, revendeursRes, eventsRes] = await Promise.all([
          getOneScanPermissionApi(scanId),
          getAllRevendeursApi("", "", "", "", 1, 10000),
          getAllEventApi(),
        ]);

        const revendeurs = revendeursRes.revendeurs.map((r) => ({
          label: `${r.firstName} ${r.lastName} (${r.email})`,
          id: r._id,
        }));
        setRevendeurOptions(revendeurs);

        const events = eventsRes.items.map((e) => ({
          label: e.eventTitle,
          id: e._id,
        }));
        setEventOptions(events);

        const currentScanData = scanRes.data;
        if (currentScanData) {
          const selectedRevendeur = revendeurs.find((r) => r.id === currentScanData.fromReseller);
          const selectedEvent = events.find((e) => e.id === currentScanData.selectedEvents);

          setFormData({
            fromReseller: selectedRevendeur || null,
            selectedEvents: selectedEvent || null,
            canScan: currentScanData.canScan,
          });
        }
      } catch (error) {
        console.error("Failed to fetch data for edit:", error);
        Swal.fire("err", "err", "error");
        navigate("/scans/voir");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [scanId, navigate]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.fromReseller || !formData.selectedEvents) {
      Swal.fire("eeerr err", " err  .", "error");
      return;
    }

    setIsLoading(true);
    try {
      const dataToUpdate = {
        fromReseller: formData.fromReseller.id,
        selectedEvents: formData.selectedEvents.id,
        canScan: formData.canScan,
      };

      await updateScanPermissionApi(scanId, dataToUpdate);

      Swal.fire(" Succ!", "sucs    .", "success");
      navigate("/scans/voir");
    } catch (error) {
      console.error("Failed to update scan permission:", error);
      Swal.fire("err", error.response?.data?.error || "   err.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
          <MDTypography>looding  ...</MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={3}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Modifer
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={revendeurOptions}
                    getOptionLabel={(option) => option.label || ""}
                    value={formData.fromReseller}
                    onChange={(event, newValue) => handleChange("fromReseller", newValue)}
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        label="(Revendeur)"
                        variant="standard"
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={eventOptions}
                    getOptionLabel={(option) => option.label || ""}
                    value={formData.selectedEvents}
                    onChange={(event, newValue) => handleChange("selectedEvents", newValue)}
                    renderInput={(params) => (
                      <MDInput {...params} label="evenment " variant="standard" required />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.canScan}
                        onChange={(e) => handleChange("canScan", e.target.checked)}
                      />
                    }
                    label="  (Can Scan)"
                  />
                </Grid>
              </Grid>
              <MDBox mt={4} mb={1}>
                <MDButton
                  variant="gradient"
                  color="info"
                  type="submit"
                  fullWidth
                  disabled={isLoading}
                >
                  {isLoading ? " loodgind..." : " enregi"}
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ModifierScan;
